import { render, staticRenderFns } from "./PartnershipE.vue?vue&type=template&id=2bb14694"
import script from "./PartnershipE.vue?vue&type=script&lang=js"
export * from "./PartnershipE.vue?vue&type=script&lang=js"
import style0 from "./PartnershipE.vue?vue&type=style&index=0&id=2bb14694&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports